import {
  getInspectionList,
  getOrderComplaintList,
  getComplaintList,
  assignComplaint,
  getComplaintInfo,
  completeComplaint,
  getDiscloseList,
  getArticles,
  dailyInspectionDraftInfo,
  saveDailyInspection,
  addCompletionCeremony,
  delInspectionDraft,
  saveNodeInspection,
  addComplaint,
  completionDetail,
  getDiscloseInfo,
  getInspectionInfo,
  getSchedulingInfo,
  saveDiscloseInfo,
  confirmStart,
  getInspectionArticle,
  getNodeArticle,
  getConstructionList,
  getConstructionInfo,
  getConstructionItem,
  saveConstructionItem,
  saveMessage,
  saveDayItems,
  getWarrantyInfo,
  getInsuranceInfo,
  orderStartList,
  orderStartBroadcast,
  getAfterList,
  getDiscloseCount,
  getOrderComplaintCount,
  getStaffRole,
  getStaffDetail,
  getChangeItems,
  getMessageList,
  getDisclosedList,
  getMessageInfo,
  getMaterials,
  getBookingList,
  saveConfide,
  getFeedbackOrderList,
  getComplaintListFeedback,
  getComplaintInfoFeedback,
  dealComplaint,
  getFields,
  addComplaintFeedback,
  getPurchaseProgress,
  getMaterialProgressOrder,
  getOrderMaterialDetail,
  getApproveNode
} from '@/api/delivery'
import { getToken, setToken, getTokenByKey, setTokenByKey } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'
const staffDetailKey = 'delivery-staff_detail'
const setStaffDetail = token => setTokenByKey(token, staffDetailKey)
import { SessionStorage } from '@/utils'
const session = new SessionStorage()

const state = {
  token: getToken(),
  staff_detail: getTokenByKey(staffDetailKey),
  def_staff_role_id: session.get('def_staff_role_id') || '',
  staff_role_list: session.getObject('staff_role_list') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_STAFF_DETAIL: (state, staff_detail) => {
    state.staff_detail = staff_detail
    setStaffDetail(JSON.stringify(staff_detail))
  },
  SET_DEF_STAFF_ROLE_ID: (state, staff_role_id) => {
    session.set('def_staff_role_id', staff_role_id)
    state.def_staff_role_id = staff_role_id
  },
  SET_STAFF_ROLE_LIST: (state, staff_role_list) => {
    session.setObject('staff_role_list', staff_role_list)
    state.staff_role_list = staff_role_list
  }
}

const actions = {

  // ====================岳辉==========================
  getInspectionList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getInspectionList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInspectionInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getInspectionInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  completionDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      completionDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveNodeInspection({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveNodeInspection(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addComplaint({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getArticles({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getArticles(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  delInspectionDraft({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      delInspectionDraft(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  dailyInspectionDraftInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      dailyInspectionDraftInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveDailyInspection({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveDailyInspection(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getWarrantyInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getWarrantyInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInsuranceInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getInsuranceInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addCompletionCeremony({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addCompletionCeremony(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // ====================晋枫==========================
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  setStaffDetail({ state, commit }, staff_detail) {
    commit('SET_TOKEN', staff_detail)
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      dispatch('setToken', token)
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
    }
  },
  async getStaffDetail({ state, commit, dispatch }, data) {
    if (state.staff_detail) {
      return state.staff_detail
    }
    try {
      const res = await dispatch('weixin/wxLogin', data, { root: true })
      const staff_info = res.data.data.staff_info
      dispatch('setStaffDetail', staff_info)
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
    }
  },
  getInspectionArticle({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getInspectionArticle(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNodeArticle({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getNodeArticle(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDiscloseList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDiscloseList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDisclosedList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDisclosedList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDiscloseInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDiscloseInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSchedulingInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSchedulingInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveDiscloseInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveDiscloseInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  orderStartBroadcast({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      orderStartBroadcast(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  confirmStart({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      confirmStart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  orderStartList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      orderStartList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConstructionList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructionList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConstructionInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructionInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConstructionItem({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructionItem(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveConstructionItem({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveConstructionItem(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveDayItems({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveDayItems(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveMessage({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveMessage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDiscloseCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDiscloseCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChangeItems({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getChangeItems(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderComplaintCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderComplaintCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffRole({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffRole(data).then(response => {
        if (response.data.data.staff_role_List.length) {
          commit('SET_STAFF_ROLE_LIST', response.data.data.staff_role_List)
        }
        if (!state.def_staff_role_id && response.data.data.staff_role_List.length) {
          commit('SET_DEF_STAFF_ROLE_ID', response.data.data.staff_role_List[0].staff_role_id)
        }
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStoreStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // ====================师琼==========================
  getOrderComplaintList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOrderComplaintList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getComplaintList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  assignComplaint({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      assignComplaint(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getComplaintInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  completeComplaint({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      completeComplaint(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAfterList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAfterList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMaterials({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMaterials(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // A-工程交底-01-获取待预约列表
  getBookingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBookingList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveConfide({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveConfide(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getFeedbackOrderList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getFeedbackOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // F-06-反馈订单问题列表
  getComplaintListFeedback(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintListFeedback(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-07-问题处理详情
  getComplaintInfoFeedback(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfoFeedback(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-08-客诉处理
  dealComplaint(temp, data) {
    return new Promise((resolve, reject) => {
      dealComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 问题选项
  getFields(temp, data) {
    return new Promise((resolve, reject) => {
      getFields(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-04-客户问题反馈
  addComplaintFeedback(temp, data) {
    return new Promise((resolve, reject) => {
      addComplaintFeedback(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // F-04-材料进度统计
  getPurchaseProgress(temp, data) {
    return new Promise((resolve, reject) => {
      getPurchaseProgress(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 1-材料进度统计-订单列表
  getMaterialProgressOrder(temp, data) {
    return new Promise((resolve, reject) => {
      getMaterialProgressOrder(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderMaterialDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getOrderMaterialDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getApproveNode(temp, data) {
    return new Promise((resolve, reject) => {
      getApproveNode(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
